import { useState, useCallback } from "react";

function useCopyToClipboard() {
  const [copiedText, setCopiedText] = useState<string | null>(null);
  const [isCopied, setIsCopied] = useState(false);

  const copy = useCallback(async (text: string) => {
    // 1. Modern API
    if (navigator?.clipboard) {
      try {
        await navigator.clipboard.writeText(text);
        handleSuccess(text);
        return true;
      } catch (err) {
        console.error("Clipboard API failed, trying fallback", err);
      }
    }

    // 2. Fallback for non-secure contexts
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        handleSuccess(text);
        return true;
      }
    } catch (err) {
      console.warn("Fallback copy failed", err);
    }

    return false;
  }, []);

  const handleSuccess = useCallback((text: string) => {
    setCopiedText(text);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  }, []);

  return [isCopied, copy] as const;
}

export default useCopyToClipboard;
